import type { OptionListItem } from '../components/ProductOption/ProductOption';

function rowScore(row: OptionListItem): number {
  const selected = row.options?.length ?? 0;
  let score = selected * 10;
  if (row.variableType && row.variableType !== 'none') score += 5;
  if (row.number != null && row.number !== 0) score += 2;
  if (row.text?.trim()) score += 2;
  if (row.unit?.trim()) score += 1;
  return score;
}

function subcategoryKey(row: OptionListItem): string {
  return String(
    (row as { subcategory?: string }).subcategory ?? row.SubCategory?._id ?? '',
  );
}

/**
 * Keep one row per subcategory, preferring the row with the most selections.
 * On a score tie the FIRST occurrence wins — this MUST match the backend
 * dedupeOptionsList tie-break so quantity/price calculations never disagree.
 * Rows without a subcategory are passed through untouched (never dropped).
 */
export function dedupeOptionListItems<T extends OptionListItem>(
  items?: T[] | null,
): T[] {
  if (!items?.length) return [];
  const seen = new Map<string, T>();
  const keyless: T[] = [];
  for (const row of items) {
    const key = subcategoryKey(row);
    if (!key) {
      keyless.push(row);
      continue;
    }
    const existing = seen.get(key);
    if (!existing) {
      seen.set(key, row);
      continue;
    }
    // Strict > keeps the first row on a tie (matches backend).
    seen.set(key, rowScore(row) > rowScore(existing) ? row : existing);
  }
  return [...seen.values(), ...keyless];
}
